import { RecordKey, gatherBy } from "./gatherBy";

export function assignBy<T extends object, K extends keyof T>(
  array: readonly T[],
  key: K
): Record<T[K], T>;

export function assignBy<T>(
  array: readonly T[],
  path: readonly RecordKey[]
): Record<RecordKey, T>;

export function assignBy<T>(
  array: readonly T[],
  genKey: (elem: T) => RecordKey
): Record<RecordKey, T>;

export function assignBy<T>(
  array: readonly T[],
  pathOrFn: any
): Record<RecordKey, T> {
  return gatherBy(array, pathOrFn, (result, key, element) => {
    result[key] = element;
  });
}
